import React from 'react';
import Icon from '@/common/components/Icon';
import { formatToDateTamplate } from '@/common/functions/dateFormater';
import { Colors } from '@/common/colors/colors';
import {
	ContactOrderItem,
	ContactOrderWrapper,
	ContactOrdersWrapper,
} from './ContactOrders.styled';

const ContactOrders = ({ selectedContact, checkedOrder, handleOrderCheck }) => {
	return (
		<ContactOrdersWrapper>
			{selectedContact.orders.map((order) => (
				<ContactOrderWrapper key={order._id}>
					<ContactOrderItem>{order.status}</ContactOrderItem>
					<ContactOrderItem>
						{order.shipping?.waybill_number || '----'}
					</ContactOrderItem>
					<ContactOrderItem>
						{order.shipping?.status_delivered_no_payment_at
							? formatToDateTamplate(
								order.shipping?.status_delivered_no_payment_at,
							)
							: '----'}
					</ContactOrderItem>
					<Icon
						name={
							checkedOrder === order._id ? 'check' : 'plus'
						}
						color={checkedOrder === order._id ? Colors.green : ''}
						onClick={() => handleOrderCheck(order._id)}
					/>
				</ContactOrderWrapper>
			))}
		</ContactOrdersWrapper>
	);
};

export default ContactOrders;
